/**
 * Environment Configuration
 * 
 * This file exports environment variables for the application.
 * Values are loaded from .env file or use defaults.
 */

export const SERVER_URL = process.env.SERVER_URL;
export const SOCKET_SERVER_URL = process.env.SOCKET_SERVER_URL;
export const API_SIGNATURE_SECRET = process.env.VITE_API_SIGNATURE_SECRET;

// Export as default object for convenience
export default {
  SERVER_URL,
  SOCKET_SERVER_URL,
  API_SIGNATURE_SECRET,
};
